import APCurrencyIcon from './APCurrencyIcon';

export {
    APCurrencyIcon
};

export default APCurrencyIcon;